import { createApiHook } from '../hooks';
import { landingPagesApiFactory } from './landingPagesApiFactory';

export const useLandingPagesApi = createApiHook(landingPagesApiFactory);
